<template>
  <router-view />
</template>

<script>
  export default {
    name: 'App',
    metaInfo () {
      return {
        title: 'AEP Projects',
        titleTemplate:
          '%s | AEP Projects',
      }
    },
    created () {
    },
    methods: {
    },
  }
</script>
